import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../Services/api.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DataGridComponent } from '../Common/Components/data-grid/data-grid.component';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { BreadcrumbComponent } from '../Common/Components/breadcrumb/breadcrumb.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { AddEditCustomerAssociateComponent } from "./add-edit-customer-associate/add-edit-customer-associate.component";
import { NzInputModule } from 'ng-zorro-antd/input';
import { SpinnerComponent } from '../Common/Components/spinner/spinner.component';
import { ConfirmPopupComponent } from '../Common/Components/confirm-popup/confirm-popup.component';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-associate-customers',
  standalone: true,
  imports: [NzButtonModule, NzInputModule, ConfirmPopupComponent, CommonModule, FormsModule, SpinnerComponent, NzIconModule, NzDrawerModule, DataGridComponent, AddEditCustomerAssociateComponent],
  templateUrl: './associate-customers.component.html',
  styleUrl: './associate-customers.component.scss'
})
export class AssociateCustomersComponent {
  constructor(private apiService: ApiService) {

  }

  userId: string = '';
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  associateCustomerColumns: any = [{
    field: 'arno',
    header: '',
    type: "checkbox"
  },
  {
    field: 'arno',
    header: 'AR #',
    compare: (a: any, b: any) => (a.arno ?? "").localeCompare((b.arno ?? "")),
    width: '100px'
  },
  {
    field: 'customerName',
    header: 'Customer Name',
    compare: (a: any, b: any) => (a.customerName ?? "").localeCompare((b.customerName ?? "")),
    width: '250px'
  },
  {
    field: 'loginPage',
    header: 'Login Page ID',
    compare: (a: any, b: any) => (a.loginPage ?? "").localeCompare((b.loginPage ?? ""))
  },
  {
    field: 'styleSheet',
    header: 'Style sheet',
    compare: (a: any, b: any) => (a.styleSheet ?? "").localeCompare((b.styleSheet ?? ""))
  },
  {
    field: 'brand',
    header: 'Brand',
    compare: (a: any, b: any) => (a.brand ?? "").localeCompare((b.brand ?? ""))
  },
  {
    field: '',
    header: 'Action',
    icons: ['edit', 'delete'],
    type: 'icon',
    showIcons: true
  }];
  associateCustomerList: any = [];
  selectedList: any = [];
  payLoadData: any = [];
  inValidForm: boolean = false;
  linkDrawer: boolean = false;
  dataLoaded: boolean = false;
  showModal: boolean = false;
  editData: any = [];
  searchText: string = '';
  originalAsscCustomerList: any[] = [];
  pageSize: number = 50;
  private scrollSubject = new Subject<void>();
  private scrollSubscription!: Subscription;
  ngOnInit() {
    this.dataLoaded = true;
    this.apiService.getAssociateCustomerList().subscribe(res => {
      this.originalAsscCustomerList = res;
      this.originalAsscCustomerList.map((node: any) => Object.assign(node, { 'pageEdit': true }));
       if (this.originalAsscCustomerList.length > 0) {
        this.associateCustomerList = this.originalAsscCustomerList.slice(0, this.pageSize);
      }
      this.dataLoaded = false;
    }, error => {
      this.dataLoaded = false;
      this.apiService.createNotification('error', error?.error?.message);
    })
    this.scrollSubscription = this.scrollSubject
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.loadNextBatch();
      });
  }
  loadNextBatch() {
    if (this.associateCustomerList.length < this.originalAsscCustomerList.length) {
      const nextBatch = this.originalAsscCustomerList.slice(
        this.associateCustomerList.length,
        this.associateCustomerList.length + this.pageSize
      );
      this.associateCustomerList = [...this.associateCustomerList, ...nextBatch];
    }
  }


  ngAfterViewChecked() {
    if (this.searchText && (this.dataGridComponent && this.dataGridComponent.searchData)) {
      setTimeout(() => {
        this.dataGridComponent.searchData(this.searchText, ['arno', 'customerName'],this.originalAsscCustomerList);
      });
    }
  }

  selectedRow(data: any) {
    this.selectedList = [...data];
  }

  deleteSelected() {
    let postObj: any = [];
    this.selectedList.map((node: any) => {
      this.originalAsscCustomerList.map((node2: any) => {
        if (node === node2.arno) {
          postObj.push({
            "arno": node2.arno,
            "customerName": node2.customerName,
            "loginPageId": node2.loginPageId,
            "styleSheet": node2.styleSheet,
            "updateType": "DELETE"
          })
        }

      })
    });

    this.showModal = true;
    this.payLoadData = postObj;
  }

  searchCustomer(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, ['arno', 'customerName'],this.originalAsscCustomerList);
  }

  updateAssociateUserList(data: any) {
    this.apiService.updateAssociateCustomerList(data).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.payLoadData = [];
      this.ngOnInit();
      this.userId = '';
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }
  deleteAssociateUser(data: any) {
    let postObj = {
      "arno": data.arno,
      "customerName": data.customerName,
      "loginPageId": data.loginPageId,
      "styleSheet": data.styleSheet,
      "updateType": "DELETE"
    }

    this.updateAssociateUserList([postObj]);
  }

  addData(data: any) {
    this.linkDrawer = false;
    this.updateAssociateUserList(data);
  }

  editRow(data: any) {
    this.linkDrawer = true;
    this.editData = [data];
  }

  closeDrawer() {
    this.linkDrawer = false;
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  onTableScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.scrollSubject.next(); // Push to the subject
    }
  }

}
